const Helpers = {
	mobile: 500,
	tablet: 768,
	desktop: 992,
	large: 1200,
	sideNav: 1321,
	numToBool: num => {
		return !!Number(num)
	},
	boolToNum: bool => {
		return Number(bool)
	},
	stringToNum: str => {
		return Number(str)
	},
	snakeToCamel: s => {
		return s.replace(/(-\w)/g, function (m) {
			return m[1].toUpperCase()
		})
	},
	addTextAttrToTextInputs: () => {
		const query = document.querySelectorAll('input')
		const inputs = Array.prototype.slice.call(query)
		return inputs.map(input => {
			if (input.type === 'text' && input.getAttribute('text') === null) {
				input.setAttribute('type', 'text')
			}
		})
	},
	updateTheme: function updateTheme(...data) {
		Object.assign(window.FOD_STORE, data)
	},
	notNull: input => input !== null,
	createElement: type => {
		return document.createElement(type)
	},
	createFragment: () => {
		return document.createDocumentFragment()
	},
	addContent: (element, content) => {
		element.textContent += content
		return element
	},
	/**************
	 *   loop through and add attributes to element
	 *   return element
	 * eg props : var someProps = [{prop: 'classList', value: 'row four'}, {prop: 'name', value: 'some name'}];
	 **************/
	addPropsToElement: (element, props) => {
		props.forEach(function (prop) {
			element[prop.prop] = prop.value
		})
		return element
	},
	appendNode: (parent, child) => {
		parent.appendChild(child)
		return parent
	},
	newElement: type => {
		return this.createElement(type)
	},
}

export default Helpers
